import React from 'react';
import { Link } from 'react-router-dom';

function HomePage() {
  return (
    <div className="auth-container">
      <div className="card">
      <h1 className="title">🐿️ 도토리 저금통</h1>
      <p className="subtitle">가족과 함께하는 미션 기반 용돈 관리</p>
      
      <div style={{ marginTop: '40px' }}>
        <h3 style={{ color: '#333', marginBottom: '20px' }}>누구세요?</h3>
        
        <Link to="/parent/login" className="btn btn-secondary" data-testid="parent-login-btn">
          👨‍👩‍👧‍👦 부모님 로그인
        </Link>
        
        <Link to="/child/login" className="btn btn-secondary" data-testid="child-login-btn">
          🧒 자녀 로그인
        </Link>
      </div>
      
      <div style={{ marginTop: '30px', paddingTop: '30px', borderTop: '1px solid #eee' }}>
        <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '15px' }}>
          처음 이용하시나요?
        </p>
        <Link to="/parent/signup" className="btn btn-secondary" data-testid="signup-btn">
          🚀 가족 등록하기
        </Link>
      </div>
      
      <div style={{ marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #eee' }}>
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap', fontSize: '0.9rem' }}>
          <Link to="/about" style={{ color: '#666', textDecoration: 'none' }}>서비스 소개</Link>
          <Link to="/terms" style={{ color: '#666', textDecoration: 'none' }}>이용약관</Link>
          <Link to="/privacy" style={{ color: '#666', textDecoration: 'none' }}>개인정보처리방침</Link>
        </div>
      </div>

      <div style={{ marginTop: '20px' }}>
        <small style={{ color: '#999' }}>
          v1.0.0 | Made with ❤️ for families
        </small>
      </div>
    </div>
    </div>
  );
}

export default HomePage;